import React from "react";
import styled from "styled-components";
import parse from "html-react-parser";

export default function LandingHero({
  title = "SPREADING THE JOY OF MOTHERHOOD",
  subTitle = "Advanced fertility treatments tailored to your individual needs with compassionate care at every step.",
  bgUrl = "/images/Home.jpeg",
  btnText = "Book Appointment",
  btnUrl = "#appointment",
  onBtnClick,
}) {
  const handleClick = (e) => {
    if (onBtnClick) {
      e.preventDefault();
      onBtnClick(e);
      return;
    }
    if (btnUrl && btnUrl.startsWith("#")) {
      const targetId = btnUrl.substring(1);
      const targetElem = document.getElementById(targetId);
      if (targetElem) {
        e.preventDefault();
        targetElem.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <HeroSection bgUrl={bgUrl}>
      <div className="container">
        <div className="landing_hero_content">
          <h1 className="landing_hero_title">{parse(title)}</h1>
          <p className="landing_hero_subtitle">{parse(subTitle)}</p>
          <a
            href={btnUrl}
            onClick={handleClick}
            className="landing_hero_btn"
            id="hero-book-appointment-btn"
          >
            {btnText}
          </a>
        </div>
      </div>
    </HeroSection>
  );
}

const HeroSection = styled.section`
  position: relative;
  width: 100%;
  min-height: 680px;
  display: flex;
  align-items: center;
  background-image: url(${props => props.bgUrl || "/images/Home.jpeg"});
  background-size: cover;
  background-position: right center;
  background-repeat: no-repeat;
  overflow: hidden;
  padding-top: 130px;
  padding-bottom: 70px;

  /* Desktop layout & content styling */
  .landing_hero_content {
    position: relative;
    z-index: 2;
    max-width: 520px;
    padding: 20px 0;
  }

  .landing_hero_title {
    font-size: 50px;
    font-weight: 800;
    line-height: 1.15;
    color: #1a2238;
    letter-spacing: -0.5px;
    margin-bottom: 22px;
    text-transform: uppercase;
  }

  .landing_hero_subtitle {
    font-size: 17px;
    line-height: 1.6;
    color: #4a5568;
    margin-bottom: 34px;
    max-width: 460px;
  }

  .landing_hero_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #f58220;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    padding: 13px 34px;
    border-radius: 50px;
    text-decoration: none;
    box-shadow: 0 4px 16px rgba(245, 130, 32, 0.38);
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;

    &:hover {
      background-color: #e06d0b;
      color: #ffffff;
      transform: translateY(-2px);
      box-shadow: 0 6px 22px rgba(245, 130, 32, 0.48);
    }

    &:active {
      transform: translateY(0);
    }
  }

  /* Large screens */
  @media (min-width: 1500px) {
    min-height: 740px;
    padding-top: 150px;
    padding-bottom: 90px;
    .landing_hero_content {
      max-width: 580px;
    }
    .landing_hero_title {
      font-size: 56px;
    }
    .landing_hero_subtitle {
      font-size: 19px;
      max-width: 500px;
    }
  }

  /* Medium screens / Laptops */
  @media (max-width: 1200px) {
    min-height: 600px;
    padding-top: 120px;
    padding-bottom: 60px;
    .landing_hero_title {
      font-size: 42px;
    }
    .landing_hero_subtitle {
      font-size: 16px;
      max-width: 420px;
    }
  }

  /* Tablets */
  @media (min-width: 768px) and (max-width: 991px) {
    min-height: 540px;
    padding-top: 110px;
    padding-bottom: 50px;
    background-position: 85% center;
    .landing_hero_content {
      max-width: 400px;
    }
    .landing_hero_title {
      font-size: 36px;
    }
    .landing_hero_subtitle {
      font-size: 15px;
    }
  }

  /* Mobile Devices (Matches Screenshot 2) */
  @media (max-width: 767px) {
    min-height: 560px;
    background-position: 72% center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 100px 16px 50px 16px;

    /* Semi-transparent soft overlay to ensure maximum readability of dark text over background image */
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.62);
      backdrop-filter: blur(1px);
      z-index: 1;
    }

    .container {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .landing_hero_content {
      max-width: 360px;
      padding: 0;
      margin: 0 auto;
      text-align: center;
    }

    .landing_hero_title {
      font-size: 28px;
      line-height: 1.25;
      margin-bottom: 14px;
      color: #1a2238;
      max-width: 320px;
      margin-left: auto;
      margin-right: auto;
    }

    .landing_hero_subtitle {
      font-size: 15px;
      line-height: 1.55;
      color: #374151;
      margin-bottom: 24px;
      max-width: 300px;
      margin-left: auto;
      margin-right: auto;
    }

    .landing_hero_btn {
      font-size: 15px;
      padding: 12px 30px;
      margin: 0 auto;
    }
  }
`;
